<footer class="text-lg-start">
  <div *ngIf="showTopFooter" class="top-footer">
    <!-- Grid container -->
    <div class=" container p-4">
      <!--Grid row-->
      <div class="row">
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-3"></div>
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-3"></div>
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-3"><a class="text-black" href="https://www.cultura.gob.es/"><img src="assets/coam/images/logotipo-cul-web.jpg" [attr.alt]="'menu.header.image.logo' | translate" style="max-height:120px;"/></a><br>Este proyecto ha recibido una ayuda del Ministerio de Cultura</div>
      </div>
      <div class="row">

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <!--
          <h5 class="text-uppercase">Footer Content</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a routerLink="./" class="">Suspendisse potenti</a>
            </li>
          </ul>-->
        </div>
        <!--Grid column-->
        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <h5 class="text-uppercase">Condiciones</h5>
          <ul class="footer-info list-unstyled small d-flex justify-content-center mb-0">
            <li>
                <a class="text-black" href="javascript:void(0);"
                (click)="showCookieSettings()">{{ 'footer.link.cookies' | translate}}</a>
            </li>
            <li *ngIf="showPrivacyPolicy">
              <a class="text-black"
                routerLink="info/privacy">{{ 'footer.link.privacy-policy' | translate}}</a>
            </li>
            <li *ngIf="showEndUserAgreement">
              <a class="text-black"
                routerLink="info/end-user-agreement">{{ 'footer.link.end-user-agreement' | translate}}</a>
            </li>
            <li *ngIf="showSendFeedback$ | async">
              <a class="text-black"
                routerLink="info/feedback">{{ 'footer.link.feedback' | translate}}</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
          <!--
          <h5 class="text-uppercase">Footer Content</h5>

          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste atque ea quis
            molestias. Fugiat pariatur maxime quis culpa corporis vitae repudiandae aliquam
            voluptatem veniam, est atque cumque eum delectus sint!
          </p>-->
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->
    </div>
  </div>
  <!-- Grid container -->

  <!-- Copyright -->

  <div *ngIf="showBottomFooter" class="bottom-footer p-1 d-flex justify-content-center align-items-center text-white w-100">
    <div class="content-container">
      <p class="m-0">


      </p><br>
      <ul class="footer-info list-unstyled small d-flex justify-content-center mb-0">
        <li>
            <a class="text-black" href="javascript:void(0);"
             (click)="showCookieSettings()">{{ 'footer.link.cookies' | translate}}</a>
        </li>
        <li *ngIf="showPrivacyPolicy">
          <a class="text-black"
             routerLink="info/privacy">{{ 'footer.link.privacy-policy' | translate}}</a>
        </li>
        <li *ngIf="showEndUserAgreement">
          <a class="text-black"
             routerLink="info/end-user-agreement">{{ 'footer.link.end-user-agreement' | translate}}</a>
        </li>
        <li *ngIf="showSendFeedback$ | async">
          <a class="text-black"
             routerLink="info/feedback">{{ 'footer.link.feedback' | translate}}</a>
        </li>
      </ul>
    </div>
  </div>
  <!-- Copyright -->
</footer>
